/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Button,
  Input,
  Row,
  Col,
  Spinner,
} from 'reactstrap';
import Select from 'react-select';
import { getAuthToken, isAuthenticated } from '../../../auth/tokenvalidation';
//import img3 from "../../../assets/images/companies/img-3.png";
import axios from 'axios';
import { api, web } from '../../../config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Alert, UncontrolledAlert } from 'reactstrap';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const FileUploadSection = ({
  ids,
  fetchDocumentUpload,
  formFileUpload,
  setFormFileUpload,
  uploadDocument,
  readonly,
}) => {
  const [fileCategory, setFileCategory] = useState({ items: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const token = getAuthToken();

  useEffect(() => {
    fetchFileCategory();
  }, []);

  const fetchFileCategory = async () => {
    try {
      const response = await fetch(
        `${api.API_URL}/document-upload/getall-master-hps-document`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.documentName,
      }));
      setFileCategory({ items });
    } catch (error) {
      console.error('Error:', error);
    } finally {
    }
  };

  const handleSelectChange = (e, field) => {
    const value = e ? e.value : '';
    const newData = {
      ...formFileUpload,
      [field]: value,
    };
    setFormFileUpload(newData);
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0]; // Ambil file pertama
    const newData = {
      ...formFileUpload,
      [field]: file, // Simpan file ke state
    };
    setFormFileUpload(newData);
  };

  const handleAddFileUpload = async e => {
    try {
      console.log(formFileUpload);
      setIsLoading(true);
      const response = await axios.post(
        `${api.API_URL}/hps/upload-hps`,
        formFileUpload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`File has been Uploaded`);
    } catch (error) {
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        fetchDocumentUpload();
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        setFormFileUpload(prev => ({
          ...prev,
          fileAttachment: null,
          DocumentUploadId: null,
        }));
      }, 500);
    }

    // finally {
    //   setIsLoading(false);
    //   fetchDocumentUpload();
    // }
  };

  const [isBookmarkClick, setIsBookmarkClick] = useState(false);
  return (
    <React.Fragment>
      <Col>
        <div className='mb-3 .bg-body-tertiary'>
          <label htmlFor='nameInput' className='form-label'>
            File Category
          </label>
          <Select
            name='DocumentUploadId'
            id='DocumentUploadId'
            options={fileCategory.items}
            placeholder='Please Select'
            value={
              fileCategory.items?.find(
                obj => obj.value === formFileUpload.DocumentUploadId
              ) || null
            }
            onChange={e => {
              handleSelectChange(e, 'DocumentUploadId');
            }}
          />
        </div>
        <div className='mb-3'>
          <label htmlFor='emailInput' className='form-label'>
            File
          </label>
          <Input
            className='form-control'
            type='file'
            id='fileAttachment'
            name='fileAttachment'
            onChange={e => handleFileChange(e, 'fileAttachment')}
            disabled={isLoading}
            innerRef={fileInputRef}
          />
        </div>

        <div className='text-end'>
          {readonly && (
            <Button
              color='success'
              className='btn-label btn btn-sm'
              onClick={() => {
                handleAddFileUpload();
              }}
              disabled={isLoading}
            >
              <i className='ri-check-double-line label-icon align-middle fs-16 '></i>
              {isLoading ? (
                <>
                  <Spinner size='sm' /> Uploading...
                </>
              ) : (
                'Upload File'
              )}
            </Button>
          )}
        </div>
      </Col>
    </React.Fragment>
  );
};

export default FileUploadSection;
